import { UrlMatchResult, UrlMatcher, UrlSegment } from '@angular/router';
import { CUSTOM_LANDING_PAGES } from './CustomLandingPages';
import { LandingPageData } from './interfaces/landing-page.types';

const LANDING_PAGES_BY_SLUG: Map<string, LandingPageData> = new Map(
  CUSTOM_LANDING_PAGES.map(page => [page.slug, page])
);

/**
 * Matchea rutas de un solo segmento (ej: '/rent-a-car-punta-arenas') contra el
 * registro de CUSTOM_LANDING_PAGES. Si el registro está vacío (caso por defecto
 * en `dev`), nunca matchea nada — no agrega rutas reales al sitio base.
 * Debe registrarse DESPUÉS de todas las rutas públicas fijas en app.routes.ts,
 * para que estas siempre tengan prioridad sobre un slug de cliente que las pise.
 */
export const landingPageMatcher: UrlMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
  if (segments.length !== 1) return null;

  const slug = segments[0].path;
  if (!LANDING_PAGES_BY_SLUG.has(slug)) return null;

  return { consumed: segments, posParams: { slug: segments[0] } };
};

export function getLandingPageBySlug(slug: string): LandingPageData | undefined {
  return LANDING_PAGES_BY_SLUG.get(slug);
}
